import React from "react";
import { default as MUISelect } from "@mui/material/Select";
import styled from "styled-components";

const StyledMUISelect = styled(MUISelect)`
  height: 50px;
  border-radius: 8px !important;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "300px")} !important;
  max-width: 80vw;
  background-color: #fff;
  font-family: var(--primaryTextFont) !important;

  &:not(.Mui-disabled) fieldset {
    background: unset;
    box-shadow: unset;
    border: 1px solid var(--colorBorder) !important;
  }

  &.Mui-focused fieldset {
    border: 2px solid var(--primaryColor) !important;
  }

  .MuiSelect-select,
  .MuiNativeSelect-select {
    font-size: 14px;
  }

  &:hover:not(.Mui-disabled):not(.Mui-focused) fieldset {
    border: 2px solid var(--colorBorder) !important;
  }

  select {
    height: 19px !important;
    border-bottom: none;
  }
`;

export const Select = (props) => {
  return <StyledMUISelect {...props} MenuProps={{ disableScrollLock: true }} />;
};
